import {Box} from '@mui/material';
import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setDrawerAccordionMaxHeight} from '../../redux/slices/clientDetailsSlice';
import {RootState} from '../../redux/store';
import {t} from 'i18next';

export type AurDrawerPanelContainerProps = {
  panelHeader?: React.ReactNode;
  contentHeader?: React.ReactNode;
  contentBody?: React.ReactNode;
  className?: string;
};

const AurDrawerPanelContainer = ({
  panelHeader,
  contentHeader,
  contentBody,
  className,
}: AurDrawerPanelContainerProps) => {
  const dispatch = useDispatch();
  const headerRef = useRef<HTMLDivElement>(null);

  const triggerResize = useSelector(
    (state: RootState) => state.department.triggerResize
  );

  useEffect(() => {
    const handleResize = () => {
      const headerHeight = headerRef.current?.offsetHeight ?? 0;
      const availableHeight = window.innerHeight - headerHeight;
      dispatch(setDrawerAccordionMaxHeight(availableHeight));
    };

    handleResize();
    window.addEventListener('resize', handleResize);
  }, [triggerResize]);

  return (
    <Box component="section" className={`${className}`}>
      <Box
        ref={headerRef}
        sx={{padding: '0px 48px', backgroundColor: '#0C1119FF'}}
        className={'aur-drawer-panel-header-container'}
      >
        {panelHeader && <Box sx={{padding: '16px 0px'}}>{panelHeader}</Box>}
        <Box
          sx={{padding: '44px 0'}}
          role="region"
          aria-label={t('fieldManagement.drawerHeader')}
        >
          {contentHeader || null}
        </Box>
      </Box>
      <Box
        component="main"
        className="aur-drawer-panel-body-container"
        aria-label={t('fieldManagement.drawerContent')}
      >
        {contentBody || null}
      </Box>
    </Box>
  );
};

export default AurDrawerPanelContainer;
